import { connect } from 'react-redux';
import React from 'react';

function LoggedRedirect() {
  return <div />;
}

export default connect()(LoggedRedirect);
